<form class="rs-form-neg">
  <div class="rs-form-item">
    <select
      id="ac-selectbox1"
      name="ac-selectbox1"
      class="rs-filled"
      [(ngModel)]="selectedProductSplitIdentifier"
      (ngModelChange)="changeOfProductSplitIdentifier($event)"
      data-cy="myBillOdbProductSplitSelect"
    >
      <option value="All" selected="selectedProductSplitIdentifier">
        {{ 'bills.cover.odbDetails.allLabel' | translate }}
      </option>
      <option
        *ngFor="let aProductSplit of productSplit"
        [ngValue]="aProductSplit.identifier"
        selected="selectedProductSplitIdentifier"
      >
        {{
          aProductSplit.identifier ??
            ('bills.cover.odbDetails.noIdentifierLabel' | translate)
        }}
      </option>
    </select>
    <label class="rs-form-label" for="ac-selectbox1">{{
      'bills.cover.odbDetails.selectLabel' | translate
    }}</label>
  </div>
</form>
